module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-send-agency-65ed6cb59ab76d266ef17cd0efe725cf.svg";